/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Formatter_Ref_N3Inputs */

const en_formatter_ref_n3 = /** @type {(inputs: Formatter_Ref_N3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A leading zero is kept, a trailing one is not.`)
};

const ko_formatter_ref_n3 = /** @type {(inputs: Formatter_Ref_N3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`앞의 0은 남고 뒤의 0은 사라집니다.`)
};

const ja_formatter_ref_n3 = /** @type {(inputs: Formatter_Ref_N3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`先頭のゼロは残り、末尾のゼロは残りません。`)
};

/**
* | output |
* | --- |
* | "A leading zero is kept, a trailing one is not." |
*
* @param {Formatter_Ref_N3Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const formatter_ref_n3 = /** @type {((inputs?: Formatter_Ref_N3Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Formatter_Ref_N3Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_formatter_ref_n3(inputs)
	if (locale === "ko") return ko_formatter_ref_n3(inputs)
	return ja_formatter_ref_n3(inputs)
});